module.exports = __webpack_public_path__ + "mkr_icon.svg?ccae70ca190740a89660cc0a37676ce8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coins/mkr_icon.svg
// module id = 1145
// module chunks = 2